export default class ThoiGian {
    constructor(thoiGianBatDau = new Date(), thoiGianCapNhat = new Date(), thoiGianKetThuc = new Date()) {
        this.thoiGianBatDau = thoiGianBatDau;
        this.thoiGianCapNhat = thoiGianCapNhat;
        this.thoiGianKetThuc = thoiGianKetThuc;
    }
}